/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FunctionComponent, ReactElement } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';
import { SkillBar } from './skill-bar';
import styled from '@emotion/styled';
import { ReportBug } from './report-bug';

const StyledDiv = styled.div`
  display: grid;
  grid-template-columns: minmax(15em, 1fr) 2fr auto auto;
  width: var(--Comp-Width);
`;

const FAQContainer = styled.div`
  display: flex;
  align-items: center;
`;

interface Props {
  value: number;
}

const ColoredLinearProgress: FunctionComponent<Props> = (props: Props): ReactElement => {
  return (
    <StyledDiv>
      <SkillBar key={1} />
      <Tooltip arrow title='Progress along the competency'>
        <div
          style={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <LinearProgress
            sx={{
              ml: 2,
              minWidth: '100%',
              height: '1.5em',
              borderRadius: '.25em'
            }}
            variant='determinate'
            {...props}
          />
          <div style={{ position: 'absolute', color: 'white' }}>
            {Math.round(props.value) + '%'}
          </div>
        </div>
      </Tooltip>
      <Tooltip arrow title='Report an issue with this question'>
        <span>
          <ReportBug />
        </span>
      </Tooltip>
      <FAQContainer>
        <Link href="https://app.its-bhss.org/site/student/" target="_blank" underline='always'>Help/FAQ</Link>
      </FAQContainer>
    </StyledDiv>
  );
};

export default ColoredLinearProgress;
